import styled from 'styled-components';

export const PlaylistWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  padding: 16px 0 0 0;
  // 100% - headerHeight - footerHeaight
  min-height: calc(100% - 138px);

  &.isLoading {
    align-items: center;
    justify-content: center;
  }
`;

export const ErrorMessage = styled.div`
  max-width: 75%;
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  color: ${({ theme }) => theme.errorMessageColor};
  text-align: center;
`;

export const ErrorMessageMain = styled.div`
  padding-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
`;

export const ErrorMessageSecondary = styled.div`
  font-size: 10px;
`;

export const ReloadButton = styled.button`
  padding: 8px 24px;
  margin-top: 16px;
  background-color: ${({ theme }) => theme.reloadButtonBackgroundColor};
  color: ${({ theme }) => theme.reloadButtonColor};
  border-radius: 4px;
  transition: background-color 0.15s ease;

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.reloadButtonBackgroundColorHovered};
  }
`;
